import {
  FetchPopularPositionsProps,
  analyticsApi,
} from "@src/service/analytics";
import { PopularProductModel } from "../../domain/models/PopularProductModel";
import { PopularProductModelMapper } from "../../domain/mapper/PopularProductModelMapper";

export const fetchPopularPositionsRepo = {
  async execute(
    props: FetchPopularPositionsProps
  ): Promise<PopularProductModel> {
    const response = await analyticsApi.fetchPopularPositions(props);

    return PopularProductModelMapper.execute(response);
  },
};
